import { cache, resetCache } from "../../utils/preferences/library";
import {
    set_user,
    receive_preferences,
    update_preference,
} from "../../reducers/Preferences/reducer";

/**
 * Change current user
 * Should reset loading, preferences
 * @param {string} userId
 */
export const setUser = (userId) => (dispatch, getState) => {
    dispatch(set_user({ userId }));
    const existing = getState().preferences.userId;
    if (existing && existing !== userId) {
        resetCache();
    }
};

/**
 * Receive user preference bundle
 * @param {string} userId
 * @param {object} preferences
 */
export const receivePreferences =
    (userId, preferences) => (dispatch, getState) => {
        const existing = getState().preferences;
        if (existing.userId !== userId) {
            return;
        }

        dispatch(receive_preferences({ preferences }));

        for (let preference in preferences) {
            if (!existing.preferences.hasOwnProperty(preference)) {
                cache(preference, preferences[preference]);
            }
        }
    };

/**
 * Update user preference
 * @param {string} userId
 * @param {string} preference
 * @param {string|number} value
 */
export const updatePreference =
    (userId, preference, value) => (dispatch, getState) => {
        if (getState().preferences.userId !== userId) {
            return;
        }
        dispatch(update_preference({ preference, value }));

        cache(preference, value);
    };
